// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentDetails_wrapper__gjA19","title":"W_PaymentDetails_title__I1atT"};